import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/gondola-web-app/app/(public)/venues/[city]/[venue]/VenueHotelsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Table","TableCaption","TableHeader","TableRow","TableHead","TableBody","TableCell"] */ "/vercel/path0/gondola-web-app/components/ui/table/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/gondola-web-app/node_modules/next/dist/client/link.js");
